<template>
  <el-table
    ref="costReviewTable"
    :data="tableData"
    height="100%"
    :border="true"
    :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
  >
    <el-table-column
      prop="field_key"
      align="center"
      min-width="120"
      label="属性名称"
      show-overflow-tooltip
      fixed="left"
    >
    </el-table-column>
    <el-table-column
      prop="field_map_txt"
      align="center"
      label="属性值"
      fixed="left"
      min-width="120"
    >
    </el-table-column>
    <el-table-column prop="is_must_txt" align="center" label="是否必选">
    </el-table-column>
    <el-table-column
      prop="is_searchable_txt"
      align="center"
      label="是否在分类页显示"
    >
    </el-table-column>
    <el-table-column prop="sort" align="center" label="排序"> </el-table-column>
    <el-table-column
      prop="tdc_owner_status"
      align="center"
      label="操作"
      width="120"
      fixed="right"
    >
      <template slot-scope="scope">
        <!-- 这个判断是天赐让改的有问题请联系郑XX18631914397 -->
        <el-button type="text" v-if="scope.row.system_type!=2" @click="onHandleEdit(scope.row)">编辑</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: "TableList",
  props: ["tableData"],
  data() {
    return {};
  },
  methods: {
    // 编辑
    onHandleEdit(e) {
      this.$emit("onHandleEdit", e);
    },
  },
};
</script>
<style lang="scss" scoped></style>
